<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .background-tab {
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 100%;
    overflow: auto;
    padding-top: utils.in_rem(16px);

    .sections-container {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(24px);
      overflow: auto;
    }
  }
</style>

<script>
  import TabGroup from "@sourcewhale/shared/svelte-design-system/components/atoms/TabGroup.svelte";
  import EducationSection from "../../../../components/BackgroundModal/EducationSection.svelte";
  import ExperienceSection from "../../../../components/BackgroundModal/ExperienceSection.svelte";
  import {
    backgroundSourceStore,
    candidateStore,
    selectedBackgroundTabStore,
  } from "../../stores";
  import BackgroundSkeleton from "./BackgroundSkeleton.svelte";
  import NoBackgroundData from "./NoBackgroundData.svelte";
  import ShareResumeHeader from "./ShareResumeHeader.svelte";

  const { meta: backgroundMeta } = backgroundSourceStore;

  const items = [
    {
      id: "resume",
      label: "Resume",
    },
    {
      id: "linkedin",
      label: "LinkedIn",
    },
  ];

  let experience = $derived($backgroundSourceStore.experience);
  let education = $derived($backgroundSourceStore.education);

  let isLoading = $derived(
    $backgroundMeta.fetching && !$backgroundMeta.firstFetchDone
  );

  let showEmptyState = $derived.by(() => {
    if (isLoading) return false;

    const hasExperienceOrEducation = experience.length || education.length;

    const hasResumeData =
      hasExperienceOrEducation && $candidateStore.resumeFileId;
    const hasLinkedinData =
      hasExperienceOrEducation && $candidateStore.linkedinUrl;

    return $selectedBackgroundTabStore === "resume"
      ? !hasResumeData
      : !hasLinkedinData;
  });
</script>

<div class="background-tab">
  <TabGroup {items} bind:selectedTab={$selectedBackgroundTabStore} />

  {#if !showEmptyState}
    <ShareResumeHeader />
  {/if}

  {#if isLoading}
    <BackgroundSkeleton />
  {:else if showEmptyState}
    <NoBackgroundData />
  {:else}
    <div class="sections-container">
      <ExperienceSection {experience} />
      <EducationSection {education} />
    </div>
  {/if}
</div>
